import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  var t = moduleName.toLowerCase().lastIndexOf('index');
  if (t !== -1) {
    moduleName = moduleName.substring(0, t - 1);
  }
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules
}, {});


const store = new Vuex.Store({
  modules,
  getters,
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js